var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"count",class:{'is-empty': !_vm.count},attrs:{"to":{name: _vm.route, params: _vm.params}}},[_vm._v(" "+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }